import { z } from 'zod';

export const checkVideosResponseSchema = z.record(z.string(), z.boolean());

export type ICheckVideosResponse = z.infer<typeof checkVideosResponseSchema>;
